import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { Icon, Table, View, Text, TableColumnOpcoes, InfiniteScroll, TableSearch } from '@components';
import { getComandos, getComandosConector, reset as resetComandos } from '@ducks/conectoresComandos';
import { formatDateTimeS, Notification } from '@utils';
import styled from 'styled-components';

const ColumnExecutado = styled(View)`
  font-size: 20px;
`;

const ColumnTipo = styled(View)`
  display: flex;
  flex-direction: row;
`;

const ColumnComando = styled(View)`
  white-space: pre-line;
`;

const IconPendente = styled(View)`
  color: #999999;
  align-items: center;
`;

const IconExecutado = styled(View)`
  color: #28a745;
`;

export default function TableComandos() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const [st1, setSt1] = useState('');
  const [st2, setSt2] = useState('');

  const comandos = useSelector(({ conectoresComandos }) => conectoresComandos.get('comandos').toArray());
  const loadingComandos = useSelector(({ conectoresComandos }) => conectoresComandos.get('loadingComandos'));
  const hasMoreComandos = useSelector(({ conectoresComandos }) => conectoresComandos.get('hasMoreComandos'));
  const xCurrentPage = useSelector(({ conectoresComandos }) => conectoresComandos.get('xCurrentPage'));

  const handleSearch = () => {
    if (!loadingComandos) {
      if (id) {
        dispatch(getComandosConector(id, xCurrentPage + 1));
      } else {
        dispatch(getComandos(xCurrentPage + 1));
      }
    }
  };

  const handleInfiniteOnLoad = () => {
    if (!hasMoreComandos) {
      Notification.warning('Todos os comandos foram retornados');
    } else {
      handleSearch();
    }
  };

  const handleReset = () => {
    dispatch(resetComandos());
  };

  useEffect(() => {
    handleReset();
  }, []);

  useEffect(() => {
    if (xCurrentPage === 0) handleSearch();
  }, [xCurrentPage]);

  const columns = [
    {
      title: 'Conector',
      dataIndex: 'conectorIdentify',
      key: 'conectorIdentify',
      width: '13%',
      ...TableSearch('conectorIdentify', 'conector', { st1, setSt1, st2, setSt2 }),
    },
    {
      title: 'Data',
      dataIndex: 'dt',
      key: 'dt',
      align: 'center',
      width: '12%',
      ...TableSearch('dt', 'data', { st1, setSt1, st2, setSt2 }),
      render: (text) => (
        <View>
          <Text>{formatDateTimeS(text)}</Text>
        </View>
      ),
    },
    {
      title: 'Tipo',
      dataIndex: 'dsComando',
      key: 'dsComando',
      width: '15%',
      ...TableSearch('dsComando', 'tipo', { st1, setSt1, st2, setSt2 }),
      render: (text, comando) => (
        <ColumnTipo>
          <Icon.MDI type="checkbox-blank-circle" style={{ color: comando.corSinalizacao }} />
          &nbsp;{text}
        </ColumnTipo>
      ),
    },
    {
      title: 'Comando',
      dataIndex: 'comando',
      key: 'comando',
      width: '45%',
      ...TableSearch('comando', 'comando', { st1, setSt1, st2, setSt2 }),
      render: (text) => <ColumnComando>{text}</ColumnComando>,
    },
    {
      title: 'Executado',
      dataIndex: 'executado',
      key: 'executado',
      align: 'center',
      width: '8%',
      render: (text) => (
        <ColumnExecutado>
          {text ? (
            <IconExecutado>
              <Icon.TipIcon icon={<Icon.CheckCircleFilled />} tip="Executado" />
            </IconExecutado>
          ) : (
            <IconPendente>
              <Icon.TipIcon icon={<Icon.MDI type="clock" />} tip="Pendente" />
            </IconPendente>
          )}
        </ColumnExecutado>
      ),
    },
    {
      title: 'Opções',
      dataIndex: 'id',
      key: 'options',
      align: 'right',
      width: '7%',
      render: (text, comando) => (
        <TableColumnOpcoes>
          <Icon.Detail action={() => history.push(`/conectores/comando/detalhes/${comando.idConfiguracao}/${comando.id}`)} />
        </TableColumnOpcoes>
      ),
    },
  ];

  return (
    <InfiniteScroll dataLength={comandos.length} next={handleInfiniteOnLoad} hasMore={!loadingComandos && hasMoreComandos}>
      <Table rowKey="id" columns={columns} dataSource={comandos} loading={loadingComandos} hidePagination />
    </InfiniteScroll>
  );
}
